export default __webpack_public_path__ + "static/media/chauffe.b151c3aa.png";